
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14.5401 17.37C11.9101 19.45 8.65012 20.76 5.09012 20.98C3.96012 21.05 3.02012 20.11 3.02012 18.98V17.25C3.01012 16.24 3.77012 15.39 4.78012 15.27L7.32012 14.98C7.93012 14.91 8.53012 15.12 8.96012 15.55L10.8001 17.39C11.6101 16.98 12.3901 16.49 13.1101 15.94L2.10012 4.93002C1.71012 4.54002 1.71012 3.91002 2.10012 3.52002C2.49012 3.13002 3.13012 3.13002 3.52012 3.52002L20.4901 20.5C20.8801 20.89 20.8801 21.52 20.4901 21.91C20.1001 22.3 19.4701 22.3 19.0801 21.91L14.5401 17.37ZM17.3901 10.8L15.5401 8.95002C15.1101 8.52002 14.9001 7.92002 14.9701 7.31002L15.2601 4.79002C15.3801 3.78002 16.2301 3.02002 17.2501 3.02002H18.9801C20.1101 3.02002 21.0501 3.96002 20.9801 5.09002C20.7601 8.66002 19.4401 11.92 17.3601 14.56L15.9301 13.13C16.4801 12.4 16.9701 11.62 17.3901 10.8Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-phone-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPhoneDisabled

    ```js
    <b-new-b-icon-phone-disabled />
    ```
</docs>


